export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details?: unknown;
  /** Errores de validación / payload extra del backend (RFC 7807 `errors`). */
  readonly errors?: unknown;
  constructor(status: number, code: string, message: string, details?: unknown, errors?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.errors = errors;
  }
}
